export default "__VITE_ASSET___qtPJ6ip__"